import { render, staticRenderFns } from "./date-picker-slim.vue?vue&type=template&id=0d879c69&"
import script from "./date-picker-slim.vue?vue&type=script&lang=js&"
export * from "./date-picker-slim.vue?vue&type=script&lang=js&"
import style0 from "./date-picker-slim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports